import { useCallback, useState } from "react";
import { CatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder";
import { MuiPopup } from "../../../../components";
import { FormBuilderContainer } from "../../../../components/formBuilder/formBuilder.container";
import { FormItemTypes, IFormBuilder } from "../../../../components/formBuilder/formBuilder.entity";
import { createRoleModuleMapping, deleteRoleModuleMapping, getRoleModuleMapping, getRoleNotInModules } from "../apiCall";
import { RoleKeys } from "../entity";

export const RoleModuleMapping = (props: any) => {
  const { request } = props;
  const [open, setOpen] = useState<boolean>(false);

  const onClose = useCallback(() => { setOpen(false) }, []);
  const onClickPlus = useCallback(() => { setOpen(true) }, []);
  const formData: IFormBuilder['formData'] = [
    {
      type: FormItemTypes.TreeList,
      name: 'Modules',
      label: 'Add Role-Module Mapping',
      value: null,
      getItems: getRoleNotInModules,
      apiKey: RoleKeys.notInModules,
      apiRequest: request,
      valueSetter: (values: any) => values?.map((item: any) => ({
        ModuleId: item.ModuleId,
        MenuId: item.MenuId,
      })),
      itemSize: 12
    }
  ]

  return (
    <>
      <CatalogBuilder
        isHeader={false}
        isAssociationButton={true}
        isRightMenu
        disableEditAction
        disableViewAction

        getPagingData={getRoleModuleMapping}
        pagingAPIrequest={request}
        pagingAPIKey={RoleKeys.getModuleMapping}

        onDelete={deleteRoleModuleMapping}
        deletePagingAPIKey={RoleKeys.deleteModuleMapping}

        visibleColumns={{
          RoleName: false
        }}
        onClickPlus={onClickPlus}

        dataGridProps={{
          initialState: {
            rowGrouping: {
              model: ['ModuleName']
            },
          },
          groupingColDef: {
            minWidth: 300,
          },
        }}
      />
      <MuiPopup openPopup={open} onClose={onClose} disableCloseIcon={true} >
        <FormBuilderContainer
          formData={formData}
          isRightMenu
          headerLabel="Add Role-Module Mapping"
          mode="add"

          createFormAPI={createRoleModuleMapping}
          createKey={RoleKeys.addModuleMapping}
          createRequest={request}

          onClose={onClose}
        />
      </MuiPopup>
    </>

  );
}